/** 门户：底部附件、产品媒体是否展示 */

const ATTACHMENTS_ATTR = 'data-cms-show-attachments'
const MEDIA_ATTR = 'data-cms-show-media'
const JSON_ATTACHMENTS_ATTR = 'cmsShowAttachments'
const JSON_MEDIA_ATTR = 'cmsShowMedia'
const MARKER_RE =
  /<div\b[^>]*data-cms-show-(?:attachments|media)=["']0["'][^>]*>\s*<\/div>/gi

function parseBoolFlag(value) {
  if (value === false || value === 0 || value === '0') return false
  if (value === true || value === 1 || value === '1') return true
  return null
}

function htmlHasFlagOff(html, attr) {
  const source = String(html || '')
  if (!source) return false
  return new RegExp(`${attr}=["']0["']`).test(source)
}

function parseBodyJsonDoc(bodyJson) {
  if (bodyJson == null || bodyJson === '') return null
  try {
    const doc = typeof bodyJson === 'string' ? JSON.parse(bodyJson) : bodyJson
    if (!doc || typeof doc !== 'object') return null
    return doc
  } catch {
    return null
  }
}

function jsonFlagValue(bodyJson, key) {
  const doc = parseBodyJsonDoc(bodyJson)
  if (!doc?.attrs || typeof doc.attrs !== 'object') return null
  return parseBoolFlag(doc.attrs[key])
}

export function stripDisplayFlagsFromHtml(html) {
  MARKER_RE.lastIndex = 0
  return String(html || '').replace(MARKER_RE, '')
}

export function stripDisplayFlagsFromBodyJson(bodyJson) {
  const wasString = typeof bodyJson === 'string' || bodyJson == null || bodyJson === ''
  const doc = parseBodyJsonDoc(bodyJson)
  if (!doc) return bodyJson || ''
  if (!doc.attrs || typeof doc.attrs !== 'object') {
    return wasString ? (typeof bodyJson === 'string' ? bodyJson : JSON.stringify(doc)) : doc
  }
  const { cmsShowAttachments: _a, cmsShowMedia: _m, ...rest } = doc.attrs
  const next = { ...doc }
  if (Object.keys(rest).length) next.attrs = rest
  else delete next.attrs
  return wasString ? JSON.stringify(next) : next
}

export function parseShowAttachments(data = {}) {
  const fromField = parseBoolFlag(data.showAttachments)
  if (fromField !== null) return fromField
  const fromJson = jsonFlagValue(data.bodyJson, JSON_ATTACHMENTS_ATTR)
  if (fromJson !== null) return fromJson
  if (htmlHasFlagOff(data.bodyHtml, ATTACHMENTS_ATTR)) return false
  return true
}

export function parseShowMedia(data = {}) {
  const fromField = parseBoolFlag(data.showMedia)
  if (fromField !== null) return fromField
  const fromJson = jsonFlagValue(data.bodyJson, JSON_MEDIA_ATTR)
  if (fromJson !== null) return fromJson
  if (htmlHasFlagOff(data.bodyHtml, MEDIA_ATTR)) return false
  return true
}
